let dirPath = 'games/page050_game0/';
let dirAudio = 'games/page050_game0/audio/';

let configGame = {
  autoCheckAllCorrect: true,
  removeInCorrects: true,
  correctBlock: false,
  rulesGame: {
    otherProperty: {
      sounds: [{ src: dirPath + 'audio/click.mp3', id: 'mouseup' }],
    },
    // itemsConfig: { shuffle: false, block: true },
    items: [
      {
        idGroup: 'source',
        idItem: 's01',
        itemsConfig: { shuffle: true, block: true },
        items: [
          {
            idGroup: 'target',
            idItem: 't01',
            correct: [{ idGroup: 'source', idItem: 's01' }],
          },
        ],
      },
      {
        idGroup: 'source',
        idItem: 's02',
        itemsConfig: { shuffle: true, block: true },
        items: [
          {
            idGroup: 'target',
            idItem: 't02',
            correct: [{ idGroup: 'source', idItem: 's02' }],
          },
        ],
      },
      {
        idGroup: 'source',
        idItem: 's03',
        itemsConfig: { shuffle: true, block: true },
        items: [
          {
            idGroup: 'target',
            idItem: 't03',
            correct: [{ idGroup: 'source', idItem: 's03' }],
          },
        ],
      },
      {
        idGroup: 'source',
        idItem: 's04',
        itemsConfig: { shuffle: true, block: true },
        items: [
          {
            idGroup: 'target',
            idItem: 't04',
            correct: [{ idGroup: 'source', idItem: 's04' }],
          },
        ],
      },
      {
        idGroup: 'source',
        idItem: 's05',
        itemsConfig: { shuffle: true, block: true },
        items: [
          {
            idGroup: 'target',
            idItem: 't05',
            correct: [{ idGroup: 'source', idItem: 's05' }],
          },
        ],
      },
      {
        idGroup: 'source',
        idItem: 's06',
        itemsConfig: { shuffle: true, block: true },
        items: [
          {
            idGroup: 'target',
            idItem: 't06',
            correct: [{ idGroup: 'source', idItem: 's06' }],
          },
        ],
      },
      {
        idGroup: 'source',
        idItem: 's07',
        itemsConfig: { shuffle: true, block: true },
        items: [
          {
            idGroup: 'target',
            idItem: 't07',
            correct: [{ idGroup: 'source', idItem: 's07' }],
          },
        ],
      },
      {
        idGroup: 'source',
        idItem: 's08',
        itemsConfig: { shuffle: true, block: true },
        items: [
          {
            idGroup: 'target',
            idItem: 't08',
            correct: [{ idGroup: 'source', idItem: 's08' }],
          },
        ],
      },
      {
        idGroup: 'source',
        idItem: 's09',
        itemsConfig: { shuffle: true, block: true },
        items: [
          {
            idGroup: 'target',
            idItem: 't09',
            correct: [{ idGroup: 'source', idItem: 's09' }],
          },
        ],
      },
      {
        idGroup: 'source',
        idItem: 's10',
        itemsConfig: { shuffle: true, block: true },
        items: [
          {
            idGroup: 'target',
            idItem: 't10',
            correct: [{ idGroup: 'source', idItem: 's10' }],
          },
        ],
      },
      {
        idGroup: 'source',
        idItem: 's11',
        itemsConfig: { shuffle: true, block: true },
        items: [
          {
            idGroup: 'target',
            idItem: 't11',
            correct: [{ idGroup: 'source', idItem: 's11' }],
          },
        ],
      },
      {
        idGroup: 'source',
        idItem: 's12',
        itemsConfig: { shuffle: true, block: true },
        items: [
          {
            idGroup: 'target',
            idItem: 't12',
            correct: [{ idGroup: 'source', idItem: 's12' }],
          },
        ],
      },
      {
        idGroup: 'source',
        idItem: 's13',
        itemsConfig: { shuffle: true, block: true },
        items: [
          {
            idGroup: 'target',
            idItem: 't13',
            correct: [{ idGroup: 'source', idItem: 's13' }],
          },
        ],
      },
      {
        idGroup: 'source',
        idItem: 's14',
        itemsConfig: { shuffle: true, block: true },
        items: [
          {
            idGroup: 'target',
            idItem: 't14',
            correct: [{ idGroup: 'source', idItem: 's14' }],
          },
        ],
      },
    ],
  },
  layout: {
    itemsConfig: {
      positions: { pos: { width: 792 }, margin: { right: 4 } },
      background: {
        text: {
          font: 'Garamond',
          size: '32px',
          textAlign: 'center',
          textBaseline: 'middle',
        },
      },
    },
    groups: [
      {
        idGroup: 'target',
        positions: {
          type: 'absolute',
          autoFit: true,
          fixTab: [
            { x: 205 - 58, y: 181 - 11 },
            { x: 205 - 58, y: 338 - 11 },
            { x: 398 - 58, y: 181 - 11 },
            { x: 398 - 58, y: 338 - 11 },
            { x: 591 - 58, y: 181 - 11 },
            { x: 591 - 58, y: 338 - 11 },
            { x: 591 - 58, y: 494 - 11 },
            { x: 591 - 58, y: 651 - 11 },
            { x: 591 - 58, y: 808 - 11 },
            { x: 784 - 58, y: 181 - 11 },
            { x: 784 - 58, y: 338 - 11 },
            { x: 784 - 58, y: 494 - 11 },
            { x: 784 - 58, y: 651 - 11 },
            { x: 784 - 58, y: 808 - 11 },
          ],
        },
        otherProperty: {
          hooks: {
            autoResize: true,
            background: { color: 'rgba(255,255,255,0.01)' },
            positions: { pos: { width: 96, height: 96 } },
            items: [{ id: 'h01' }],
          },
        },
        items: [
          {
            id: 't01',
            otherProperty: {
              audio: ['a01'],
              hooks: { background: { image: { color: 'rgba(0,0,0,0.01)' } } },
            },
          },
          {
            id: 't02',
            otherProperty: {
              audio: ['a02'],
              hooks: { background: { image: { color: 'rgba(0,0,0,0.01)' } } },
            },
          },
          {
            id: 't03',
            otherProperty: {
              audio: ['a03'],
              hooks: { background: { image: { color: 'rgba(0,0,0,0.01)' } } },
            },
          },
          {
            id: 't04',
            otherProperty: {
              audio: ['a04'],
              hooks: { background: { image: { color: 'rgba(0,0,0,0.01)' } } },
            },
          },
          {
            id: 't05',
            otherProperty: {
              audio: ['a05'],
              hooks: { background: { image: { color: 'rgba(0,0,0,0.01)' } } },
            },
          },
          {
            id: 't06',
            otherProperty: {
              audio: ['a06'],
              hooks: { background: { image: { color: 'rgba(0,0,0,0.01)' } } },
            },
          },
          {
            id: 't07',
            otherProperty: {
              audio: ['a07'],
              hooks: { background: { image: { color: 'rgba(0,0,0,0.01)' } } },
            },
          },
          {
            id: 't08',
            otherProperty: {
              audio: ['a08'],
              hooks: { background: { image: { color: 'rgba(0,0,0,0.01)' } } },
            },
          },
          {
            id: 't09',
            otherProperty: {
              audio: ['a09'],
              hooks: { background: { image: { color: 'rgba(0,0,0,0.01)' } } },
            },
          },
          {
            id: 't10',
            otherProperty: {
              audio: ['a10'],
              hooks: { background: { image: { color: 'rgba(0,0,0,0.01)' } } },
            },
          },
          {
            id: 't11',
            otherProperty: {
              audio: ['a11'],
              hooks: { background: { image: { color: 'rgba(0,0,0,0.01)' } } },
            },
          },
          {
            id: 't12',
            otherProperty: {
              audio: ['a12'],
              hooks: { background: { image: { color: 'rgba(0,0,0,0.01)' } } },
            },
          },
          {
            id: 't13',
            otherProperty: {
              audio: ['a13'],
              hooks: { background: { image: { color: 'rgba(0,0,0,0.01)' } } },
            },
          },
          {
            id: 't14',
            otherProperty: {
              audio: ['a14'],
              hooks: { background: { image: { color: 'rgba(0,0,0,0.01)' } } },
            },
          },
        ],
      },
      {
        idGroup: 'source',
        positions: {
          type: 'absolute',
          autoFit: true,
          fixTab: [
            { x: 921, y: 397 }, // legs
            { x: 905, y: 603 }, // hands
            { x: 1605, y: 125 }, // head
            { x: 1330, y: 105 }, // tummy
            { x: 1130, y: 234 }, // stretch
            { x: 1607, y: 569 }, // shake
            { x: 1552, y: 295 }, // pat
            { x: 1247, y: 841 }, // hat
            { x: 986, y: 138 }, // tshirt
            { x: 1054, y: 748 }, // dress
            { x: 1441, y: 745 }, // jumper
            { x: 1235, y: 602 }, // jacket
            { x: 1420, y: 557 }, // shoes
            { x: 900, y: 811 }, // jeans
          ],
        },
        itemsConfig: {
          background: { color: 'rgba(255,255,255,0.01)' },
          positions: {
            pos: { width: 219, height: 219 },
            // rows: 1,
            // margin: { right: 38 },
          },
        },
        // positions: {
        //   type: 'absolute',
        //   pos: { x: 80, y: 920 },
        // },
        items: [
          {
            id: 's01',
            background: {
              image: { src: dirPath + 'img/legs.webp', pos: { width: 217, height: 169, x: 0, y: (217 - 169) / 2 } },
            },
            positions: { pos: { width: 217, height: 217 } },
          },
          {
            id: 's02',
            background: {
              image: { src: dirPath + 'img/hands.webp', pos: { width: 215, height: 155, x: 0, y: (215 - 155) / 2 } },
            },
            positions: { pos: { width: 215, height: 215 } },
          },
          {
            id: 's03',
            background: {
              image: { src: dirPath + 'img/tummy.webp', pos: { width: 182, height: 149, x: 0, y: (182 - 149) / 2 } },
            },
            positions: { pos: { width: 182, height: 182 } },
          },
          {
            id: 's04',
            background: {
              image: { src: dirPath + 'img/head.webp', pos: { width: 268, height: 213, x: 0, y: (268 - 213) / 2 } },
            },
            positions: { pos: { width: 268, height: 268 } },
          },
          {
            id: 's05',
            background: {
              image: { src: dirPath + 'img/strech.webp', pos: { width: 189, height: 310, x: (310 - 189) / 2, y: 0 } },
            },
            positions: { pos: { width: 310, height: 310 } },
          },
          {
            id: 's06',
            background: {
              image: { src: dirPath + 'img/shake.webp', pos: { width: 225, height: 289, x: (289 - 225) / 2, y: 0 } },
            },
            positions: { pos: { width: 289, height: 289 } },
          },
          {
            id: 's07',
            background: {
              image: { src: dirPath + 'img/pat.webp', pos: { width: 242, height: 303, x: (303 - 242) / 2, y: 0 } },
            },
            positions: { pos: { width: 303, height: 303 } },
          },
          {
            id: 's08',
            background: {
              image: { src: dirPath + 'img/hat.webp', pos: { width: 165, height: 126, x: 0, y: (165 - 126) / 2 } },
            },
            positions: { pos: { width: 165, height: 165 } },
          },
          {
            id: 's09',
            background: {
              image: { src: dirPath + 'img/tshirt.webp', pos: { width: 198, height: 191, x: (198 - 191) / 2, y: 0 } },
            },
            positions: { pos: { width: 198, height: 198 } },
          },
          {
            id: 's10',
            background: {
              image: { src: dirPath + 'img/dress.webp', pos: { width: 159, height: 206, x: (206 - 159) / 2, y: 0 } },
            },
            positions: { pos: { width: 206, height: 206 } },
          },
          {
            id: 's11',
            background: {
              image: { src: dirPath + 'img/jumper.webp', pos: { width: 191, height: 185, x: 0, y: (191 - 185) / 2 } },
            },
            positions: { pos: { width: 191, height: 191 } },
          },
          {
            id: 's12',
            background: {
              image: { src: dirPath + 'img/jacket.webp', pos: { width: 169, height: 174, x: (174 - 169) / 2, y: 0 } },
            },
            positions: { pos: { width: 174, height: 174 } },
          },
          {
            id: 's13',
            background: {
              image: { src: dirPath + 'img/shoes.webp', pos: { width: 141, height: 127, x: 0, y: (141 - 127) / 2 } },
            },
            positions: { pos: { width: 141, height: 141 } },
          },
          {
            id: 's14',
            background: {
              image: { src: dirPath + 'img/jeans.webp', pos: { width: 102, height: 137, x: (137 - 102) / 2, y: 0 } },
            },
            positions: { pos: { width: 137, height: 137 } },
          },
        ],
      },
    ],
  },
};

let dataConfig = {
  // blockCheck: true,
  mainImage: {
    imagePath: dirPath + 'img/bcg.webp',
  },
  fullscreen: true,
  mixinEngine: 'dnd',
  mbAudioItemData: [
    {
      id: 'a01',
      src: dirAudio + '57_legs.mp3',
      audioConfig: {
        autoplay: false,
        loop: false,
        volume: 1,
      },
      iconConfig: {
        src: { iconOn: 'games/page050_game0/img/audioOn.png', iconOff: 'games/page050_game0/img/audioOff.png' },
        fill: 'black',
      },
      pos: {
        y: 16,
        x: -55,
      },
      width: '67px',
      height: '67px',
      unit: 'px',
    },
    {
      id: 'a02',
      src: dirAudio + '58_hands.mp3',
      audioConfig: {
        autoplay: false,
        loop: false,
        volume: 1,
      },
      iconConfig: {
        src: { iconOn: 'games/page050_game0/img/audioOn.png', iconOff: 'games/page050_game0/img/audioOff.png' },
        fill: 'black',
      },
      pos: {
        y: 16,
        x: -55,
      },
      width: '67px',
      height: '67px',
      unit: 'px',
    },
    {
      id: 'a03',
      src: dirAudio + '60_tummy.mp3',

      audioConfig: {
        autoplay: false,
        loop: false,
        volume: 1,
      },
      iconConfig: {
        src: { iconOn: 'games/page050_game0/img/audioOn.png', iconOff: 'games/page050_game0/img/audioOff.png' },
        fill: 'black',
      },
      pos: {
        y: 16,
        x: -55,
      },
      width: '67px',
      height: '67px',
      unit: 'px',
    },
    {
      id: 'a04',
      src: dirAudio + '59_head.mp3',
      audioConfig: {
        autoplay: false,
        loop: false,
        volume: 1,
      },
      iconConfig: {
        src: { iconOn: 'games/page050_game0/img/audioOn.png', iconOff: 'games/page050_game0/img/audioOff.png' },
        fill: 'black',
      },
      pos: {
        y: 16,
        x: -55,
      },
      width: '67px',
      height: '67px',
      unit: 'px',
    },
    {
      id: 'a05',
      src: dirAudio + '61_stretch.mp3',
      audioConfig: {
        autoplay: false,
        loop: false,
        volume: 1,
      },
      iconConfig: {
        src: { iconOn: 'games/page050_game0/img/audioOn.png', iconOff: 'games/page050_game0/img/audioOff.png' },
        fill: 'black',
      },
      pos: {
        y: 16,
        x: -55,
      },
      width: '67px',
      height: '67px',
      unit: 'px',
    },
    {
      id: 'a06',
      src: dirAudio + '62_shake.mp3',
      audioConfig: {
        autoplay: false,
        loop: false,
        volume: 1,
      },
      iconConfig: {
        src: { iconOn: 'games/page050_game0/img/audioOn.png', iconOff: 'games/page050_game0/img/audioOff.png' },
        fill: 'black',
      },
      pos: {
        y: 16,
        x: -55,
      },
      width: '67px',
      height: '67px',
      unit: 'px',
    },
    {
      id: 'a07',
      src: dirAudio + '63_pat.mp3',
      audioConfig: {
        autoplay: false,
        loop: false,
        volume: 1,
      },
      iconConfig: {
        src: { iconOn: 'games/page050_game0/img/audioOn.png', iconOff: 'games/page050_game0/img/audioOff.png' },
        fill: 'black',
      },
      pos: {
        y: 16,
        x: -55,
      },
      width: '67px',
      height: '67px',
      unit: 'px',
    },
    {
      id: 'a08',
      src: dirAudio + '64_hat.mp3',
      audioConfig: {
        autoplay: false,
        loop: false,
        volume: 1,
      },
      iconConfig: {
        src: { iconOn: 'games/page050_game0/img/audioOn.png', iconOff: 'games/page050_game0/img/audioOff.png' },
        fill: 'black',
      },
      pos: {
        y: 16,
        x: -55,
      },
      width: '67px',
      height: '67px',
      unit: 'px',
    },
    {
      id: 'a09',
      src: dirAudio + '65_T-shirt.mp3',
      audioConfig: {
        autoplay: false,
        loop: false,
        volume: 1,
      },
      iconConfig: {
        src: { iconOn: 'games/page050_game0/img/audioOn.png', iconOff: 'games/page050_game0/img/audioOff.png' },
        fill: 'black',
      },
      pos: {
        y: 16,
        x: -55,
      },
      width: '67px',
      height: '67px',
      unit: 'px',
    },
    {
      id: 'a10',
      src: dirAudio + '66_dress.mp3',
      audioConfig: {
        autoplay: false,
        loop: false,
        volume: 1,
      },
      iconConfig: {
        src: { iconOn: 'games/page050_game0/img/audioOn.png', iconOff: 'games/page050_game0/img/audioOff.png' },
        fill: 'black',
      },
      pos: {
        y: 16,
        x: -55,
      },
      width: '67px',
      height: '67px',
      unit: 'px',
    },
    {
      id: 'a11',
      src: dirAudio + '67_jumper.mp3',
      audioConfig: {
        autoplay: false,
        loop: false,
        volume: 1,
      },
      iconConfig: {
        src: { iconOn: 'games/page050_game0/img/audioOn.png', iconOff: 'games/page050_game0/img/audioOff.png' },
        fill: 'black',
      },
      pos: {
        y: 16,
        x: -55,
      },
      width: '67px',
      height: '67px',
      unit: 'px',
    },
    {
      id: 'a12',
      src: dirAudio + '68_jacket.mp3',
      audioConfig: {
        autoplay: false,
        loop: false,
        volume: 1,
      },
      iconConfig: {
        src: { iconOn: 'games/page050_game0/img/audioOn.png', iconOff: 'games/page050_game0/img/audioOff.png' },
        fill: 'black',
      },
      pos: {
        y: 16,
        x: -55,
      },
      width: '67px',
      height: '67px',
      unit: 'px',
    },
    {
      id: 'a13',
      src: dirAudio + '69_shoes.mp3',
      audioConfig: {
        autoplay: false,
        loop: false,
        volume: 1,
      },
      iconConfig: {
        src: { iconOn: 'games/page050_game0/img/audioOn.png', iconOff: 'games/page050_game0/img/audioOff.png' },
        fill: 'black',
      },
      pos: {
        y: 16,
        x: -55,
      },
      width: '67px',
      height: '67px',
      unit: 'px',
    },
    {
      id: 'a14',
      src: dirAudio + '70_jeans.mp3',
      audioConfig: {
        autoplay: false,
        loop: false,
        volume: 1,
      },
      iconConfig: {
        src: { iconOn: 'games/page050_game0/img/audioOn.png', iconOff: 'games/page050_game0/img/audioOff.png' },
        fill: 'black',
      },
      pos: {
        y: 16,
        x: -55,
      },
      width: '67px',
      height: '67px',
      unit: 'px',
    },
  ],
  configGame: configGame,
};

export default dataConfig;
